import { useDateFormatter } from '../hooks';

type FormattedDateBoxProps = {
  value: string;
  displayWithHours?: boolean;
};

export const FormattedDateBox = ({ value, displayWithHours = true }: FormattedDateBoxProps) => {
  const formatDate = useDateFormatter({ displayWithHours });

  return <div>{formatDate(value)}</div>;
};
